import React, { createContext, useContext } from "react"

const LanguageContext = createContext({})

export const LanguageProvider = ({ children, lang }) => (
  <LanguageContext.Provider value={{ lang }}>{children}</LanguageContext.Provider>
)

export const useExportMagLang = () => {
  const { lang } = useContext(LanguageContext)

  return { exportMagLang: lang }
}

export const useTranslation = () => {
  const { lang = `ru` } = useContext(LanguageContext)

  return { lang }
}
